/**
 * Workshop Booking — calendar month/window math (pure).
 * Single responsibility: year-month keys and inclusive date bounds.
 */
(function (global) {
  if (global.WorkshopBookingCalendarWindow) return;

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function ymKey(year, month1to12) {
    return year + '-' + pad2(month1to12);
  }

  function shiftYm(year, month1to12, delta) {
    var d = new Date(year, month1to12 - 1 + delta, 1);
    return { year: d.getFullYear(), month: d.getMonth() + 1 };
  }

  function monthDateBounds(year, month1to12) {
    var last = new Date(year, month1to12, 0).getDate();
    return {
      from: year + '-' + pad2(month1to12) + '-01',
      to: year + '-' + pad2(month1to12) + '-' + pad2(last)
    };
  }

  function windowDateBounds(year, month1to12, lookaheadMonths) {
    var look = Number(lookaheadMonths);
    if (!Number.isFinite(look) || look < 0) look = 0;
    var start = monthDateBounds(year, month1to12);
    var endYm = shiftYm(year, month1to12, look);
    var end = monthDateBounds(endYm.year, endYm.month);
    return { from: start.from, to: end.to };
  }

  global.WorkshopBookingCalendarWindow = {
    pad2: pad2,
    ymKey: ymKey,
    shiftYm: shiftYm,
    monthDateBounds: monthDateBounds,
    windowDateBounds: windowDateBounds
  };
})(typeof window !== 'undefined' ? window : this);
